import React from 'react'

const PlugChannel = ({ className = '', color = '#414958' }) => {
  return (
    <svg
      width="13"
      height="20"
      viewBox="0 0 13 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.5 0C5.66576 0 5.82473 0.065848 5.94194 0.183058C6.05915 0.300269 6.125 0.45924 6.125 0.625V3.75H9.875V0.625C9.875 0.45924 9.94085 0.300269 10.0581 0.183058C10.1753 0.065848 10.3342 0 10.5 0C10.6658 0 10.8247 0.065848 10.9419 0.183058C11.0592 0.300269 11.125 0.45924 11.125 0.625V3.75H12.375C12.5408 3.75 12.6997 3.81585 12.8169 3.93306C12.9342 4.05027 13 4.20924 13 4.375V8.125C13 9.28532 12.5391 10.3981 11.7186 11.2186C10.8981 12.0391 9.78532 12.5 8.625 12.5C8.6225 13.0425 8.6125 13.5563 8.575 14.025C8.52375 14.6675 8.4175 15.2788 8.17875 15.805C7.9367 16.3616 7.50783 16.8161 6.96625 17.09C6.40625 17.375 5.71125 17.5 4.875 17.5C3.6275 17.5 2.8625 17.9125 2.4075 18.3975C1.9967 18.8313 1.76228 19.4027 1.75 20H0.5C0.5 19.23 0.79 18.2913 1.49625 17.54C2.2175 16.775 3.32625 16.25 4.875 16.25C5.60125 16.25 6.0775 16.14 6.3975 15.9762C6.69875 15.8225 6.8975 15.6012 7.04 15.2887C7.19125 14.9563 7.28125 14.5125 7.3275 13.9262C7.36125 13.5012 7.37125 13.0288 7.37375 12.5C6.21364 12.4997 5.10117 12.0386 4.28097 11.2182C3.46076 10.3977 3 9.28511 3 8.125V4.375C3 4.20924 3.06585 4.05027 3.18306 3.93306C3.30027 3.81585 3.45924 3.75 3.625 3.75H4.875V0.625C4.875 0.45924 4.94085 0.300269 5.05806 0.183058C5.17527 0.065848 5.33424 0 5.5 0V0ZM4.25 5V8.125C4.25 8.9538 4.57924 9.74866 5.16529 10.3347C5.75134 10.9208 6.5462 11.25 7.375 11.25H8.625C9.4538 11.25 10.2487 10.9208 10.8347 10.3347C11.4208 9.74866 11.75 8.9538 11.75 8.125V5H4.25Z"
        fill={color}
      />
    </svg>
  )
}

export default PlugChannel
